import { makeStyles } from '@mui/styles';

const useStyles: any = makeStyles((theme: any) => ({
  panelContainer: {
    padding: "16px 24px",
    backgroundColor: theme.tables.headerCell.backgroundColor,
  },
  itemsList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    marginBottom: "16px",
    maxHeight: "220px",
    overflowY: "auto"
  },
  itemRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "6px 12px",
    borderRadius: "4px",
    backgroundColor: "#fff",
    fontSize: "13px",
  },
  itemMeta: {
    color: "#79797d",
    marginInlineStart: "8px",
  },
  emptyState: {
    fontSize: "13px",
    color: "#79797d",
    padding: "8px 0"
  },
  addForm: {
    display: "flex",
    alignItems: "flex-end",
    gap: "12px",
    flexWrap: "wrap"
  },
  nameField: {
    minWidth: "180px",
  },
  typeField: {
    minWidth: "160px",
  },
  addButton: {
    height: "36px",
  }
}));

export default useStyles;
